import { useState } from "react";
import Modal from "react-modal";
import useKeypress from "../ownHooks/pressEsc";
import { MyModalButtons, MyModalCloseButton, MyModalForm } from "../StyleSheets/ModalStyle";
import { FehlerauswertungErrResp } from "../Fehler/FehlerauswertungErrResp";
import { MyCancelButton, MyNewButton, MySaveButton } from "../StyleSheets/GeneralButtonStyles";

export default function InfraCreate({ bhfListe, absInstance, strVerlInstance, reload }) {
    const [showModal, setShowModal] = useState(false);
    const [verlauf, setVerlauf] = useState([]);
    const [newStrecke, setNewStrecke] = useState({
        'id_bhf_start': undefined,
        'id_bhf_ende': undefined
    });
    const [restrictedBhfListe, setRestrictedBhfListe] = useState(bhfListe);
    const [selectionMenuLabel, setSelectionMenuLabel] = useState("Startet am Bahnhof");
    const [lastItem, setLastItem] = useState();

    const getNameOfBhf = (idBhf) => {
        console.log("name von id, bhfListe", idBhf, bhfListe)
        return bhfListe.filter(bhf => bhf.id === parseInt(idBhf))[0].bahnhof;
    }

    const resetLastItem = () => {
        setLastItem(
            {
                'pos': -1,
                'id_bhf': undefined,
                'bhf': undefined
            }
        );
        setVerlauf([]);
    }

    const resetNewStrecke = () => {
        setNewStrecke(
            {
                'id_bhf_start': undefined,
                'id_bhf_ende': undefined
            }
        );
    }

    const openModal = event => {
        setRestrictedBhfListe(bhfListe);
        resetLastItem();
        setShowModal(true);
    }

    useKeypress('Escape', () => {
        closeModal();
    });

    const closeModal = event => {
        setShowModal(false);
        resetNewStrecke();
        setSelectionMenuLabel("Startet am Bahnhof");
    }

    const saveLastBhf = (idBhf) => {
        setLastItem(
            {
                'pos': lastItem['pos'] + 1,
                'id_bhf': idBhf,
                'bhf': getNameOfBhf(idBhf)
            }
        );
    }

    const addNextBhf = (event) => {
        var lastId = event.target.value;
        console.log("bhf: ", lastId);
        console.log("bisher liste", restrictedBhfListe);
        let reload = new Promise((resolve) => {
            absInstance.getListOfPossibleBahnhoefe(lastId, (error, data) => {
                if (error) {
                    console.log(error);
                    resolve(error);
                } else {
                    setRestrictedBhfListe(data);
                    resolve(data);
                }
            });
        })
        reload.then((msg) => {
                    console.log("neue liste", restrictedBhfListe);
            saveLastBhf(lastId);
            setSelectionMenuLabel("nächster Bahnhof:");
            if (lastItem.pos === -1) {
                setNewStrecke({ 'id_bhf_start': lastId });
            }
            setNewStrecke(previous => ({ ...previous, 'id_bhf_ende': lastId }));
            setVerlauf(pre =>
                [...pre, { 'pos': lastItem.pos + 1, 'id_bhf': lastId, 'bhf': getNameOfBhf(lastId) }]
            );
        })
    }

    const submitForm = event => {
        event.preventDefault();
        console.log("speichere", newStrecke, " und ", verlauf);
        strVerlInstance.createStreckenverlauf(verlauf, (error, data, response) => {
            if (error) {
                FehlerauswertungErrResp(error, response);
            } else {
                console.log("saved", data);
                alert("Neue Strecke wurde angelegt.");
                reload();
                closeModal();
            }
        })
    }

    function deleteLastOne(event) {
        event.preventDefault();
        var toDelete = verlauf.pop();
        console.log("entfernt: ", toDelete);
        var oldEnd = verlauf.pop();
        setVerlauf(verlauf);
        let reload = new Promise((resolve) => {
            absInstance.getListOfPossibleBahnhoefe(oldEnd.id_bhf, (error, data) => {
                if (error) {
                    console.log(error);
                    resolve(error);
                } else {
                    setRestrictedBhfListe(data);
                    resolve(data);
                }
            });
        })
        reload.then((msg) => {
            saveLastBhf(oldEnd.id_bhf);
            setSelectionMenuLabel("nächster Bahnhof:");
            if (lastItem.pos === -1) {
                setNewStrecke({ 'id_bhf_start': oldEnd.id_bhf });
            }
            setNewStrecke(previous => ({ ...previous, 'id_bhf_ende': oldEnd.id_bhf }));
            setVerlauf(pre =>
                [...pre, oldEnd]
            );
        })
    }

    return (
        <div>
            <MyNewButton onClick={openModal}>&#43; neue Strecke</MyNewButton>
            <Modal isOpen={showModal} className="modal">
                <MyModalCloseButton onClick={closeModal}>&#10007; </MyModalCloseButton>
                <MyModalForm onSubmit={submitForm}>
                    <h3>Neue Strecke erstellen:</h3>
                    <label>
                        Start am Bahnhof:
                        {newStrecke['id_bhf_start'] ? getNameOfBhf(newStrecke['id_bhf_start']) : "-"}
                    </label>
                    <br></br>
                    <label>
                        Endet am Bahnhof:
                        {newStrecke['id_bhf_ende'] ? getNameOfBhf(newStrecke['id_bhf_ende']) : "-"}
                    </label>
                    <br></br>
                    <label>
                        Anzahl Bahnhöfe:
                        {verlauf.length}
                    </label>
                    <br></br>
                    <ul type="none">
                        {verlauf.map((bhf, index) =>
                            <li key={`${index}-${bhf.id_bhf}`}><label>Bahnhof {index + 1}: {bhf.bhf}</label></li>
                        )}
                    </ul>
                    <button disabled={verlauf.length < 2} onClick={deleteLastOne}>Schritt zurück</button>
                    <label>{selectionMenuLabel}
                        <select onChange={addNextBhf}>
                            <option id={0} key={0} defaultValue hidden>---Bahnhof wählen---</option>
                            {restrictedBhfListe.map(bhf =>
                                <option value={bhf.id} key={bhf.id}>{bhf.bahnhof}-{bhf.id}</option>
                            )}
                        </select>
                    </label>
                    <MyModalButtons>
                        <MySaveButton type="submit">Speichern</MySaveButton>
                        <MyCancelButton onClick={closeModal}>Abbruch</MyCancelButton>
                    </MyModalButtons>
                    <aside>
                        <ul type="none" style={{ borderTop: "1px solid black", borderBottom: "1px solid black", padding: "0.5em 1em", width: "max-content" }}>
                            <h4 style={{ margin: "0" }}>Anmerkung:</h4>
                            <li>Es werden nur Bahnhöfe mit entsprechend hinterlegtem Abschnitt in der Auswahl angeboten.</li>
                        </ul>
                    </aside>
                </MyModalForm>
            </Modal>
        </div>
    )
}